/**
 * Kontroll av jordkalibreringen per kasse (tørr og våt rå ADC i `potter`).
 * I 2.0 stor måler sensorene gjennom koppveggen og gir andre tall enn de felles
 * (3200/1140, utils), så kassa kan få egne. Samme minstespenn som firmwaren
 * (logic.MIN_JORD_SPENN), som viser ukjent fukt på skjermen for et ugyldig par.
 */

/** Minste avstand mellom tørr og våt. Under dette blir prosenten bare støy. */
export const MIN_JORD_SPENN = 100;
export const ADC_MAKS = 4095;

export function jordKalibreringFeil(torr: number, vaat: number): string | null {
  for (const v of [torr, vaat]) {
    if (!Number.isInteger(v) || v < 0 || v > ADC_MAKS) return `Rå ADC er et heltall fra 0 til ${ADC_MAKS}.`;
  }
  if (torr <= vaat) return 'Tørr jord skal gi høyere tall enn våt.';
  if (torr - vaat < MIN_JORD_SPENN) {
    return `Bare ${torr - vaat} mellom tørr og våt. Minst ${MIN_JORD_SPENN} trengs, ellers blir prosenten bare støy.`;
  }
  return null;
}
